import React, { useState, useEffect } from 'react';
import api from '../../utils/api';

export default function SuperReportsPage() {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get('/reports/superadmin')
      .then(r => setData(r.data))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  if (loading) return <div className="page-content"><p style={{ color:'var(--color-text-muted)' }}>Cargando reportes...</p></div>;
  if (!data) return <div className="page-content"><p style={{ color:'var(--color-text-muted)' }}>No hay datos disponibles</p></div>;

  return (
    <div className="page-content">
      <div className="page-header">
        <div>
          <h1 className="page-title">Reportes de Plataforma</h1>
          <p className="page-subtitle">Visión global del negocio SaaS</p>
        </div>
      </div>

      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(160px,1fr))', gap: '1rem', marginBottom: '2rem' }}>
        {[
          { label: 'Negocios Activos', value: data.active_businesses || 0 },
          { label: 'Total Usuarios', value: data.total_users || 0 },
          { label: 'Citas del Mes', value: data.monthly_appointments || 0 },
          { label: 'Clientes Registrados', value: data.total_clients || 0 },
        ].map((s, i) => (
          <div key={i} className="stat-card">
            <div className="stat-value">{s.value}</div>
            <div className="stat-label">{s.label}</div>
          </div>
        ))}
      </div>

      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '1.5rem' }}>
        {/* Top businesses */}
        <div className="card">
          <div style={{ padding: '1.25rem 1.5rem', borderBottom: '1px solid var(--color-border)' }}>
            <h3 style={{ margin: 0, fontSize: '1rem', color: 'var(--color-gold)' }}>Negocios con más citas</h3>
          </div>
          <div style={{ padding: '1.5rem' }}>
            {(data.top_businesses || []).length === 0 ? (
              <p style={{ color: 'var(--color-text-muted)', textAlign: 'center' }}>Sin datos</p>
            ) : (
              <div style={{ display: 'flex', flexDirection: 'column', gap: '0.75rem' }}>
                {data.top_businesses.map((b, i) => (
                  <div key={i} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '0.75rem 1rem', background: 'var(--color-surface)', borderRadius: '8px' }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '0.75rem' }}>
                      <span style={{ fontWeight: 700, color: 'var(--color-gold)', width: '20px' }}>#{i+1}</span>
                      <span style={{ fontWeight: 600 }}>{b.name}</span>
                    </div>
                    <span className="badge badge-info">{b.appointment_count} citas</span>
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>

        {/* Plans distribution */}
        <div className="card">
          <div style={{ padding: '1.25rem 1.5rem', borderBottom: '1px solid var(--color-border)' }}>
            <h3 style={{ margin: 0, fontSize: '1rem', color: 'var(--color-gold)' }}>Distribución por Plan</h3>
          </div>
          <div style={{ padding: '1.5rem' }}>
            {(data.plan_distribution || []).length === 0 ? (
              <p style={{ color: 'var(--color-text-muted)', textAlign: 'center' }}>Sin datos</p>
            ) : (
              <div style={{ display: 'flex', flexDirection: 'column', gap: '0.75rem' }}>
                {data.plan_distribution.map((p, i) => {
                  const colors = { basic: '#6366f1', medium: '#3b82f6', premium: '#c9a84c' };
                  const color = colors[p.plan_name?.toLowerCase()] || '#888';
                  const max = Math.max(...data.plan_distribution.map(x => x.count));
                  const pct = Math.round((p.count / max) * 100);
                  return (
                    <div key={i}>
                      <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '4px', fontSize: '0.85rem' }}>
                        <span style={{ fontWeight: 600, textTransform: 'capitalize' }}>{p.plan_name}</span>
                        <span style={{ color: 'var(--color-text-muted)' }}>{p.count} negocios</span>
                      </div>
                      <div style={{ height: '8px', background: 'var(--color-border)', borderRadius: '4px', overflow: 'hidden' }}>
                        <div style={{ height: '100%', width: `${pct}%`, background: color, borderRadius: '4px', transition: 'width 0.5s' }} />
                      </div>
                    </div>
                  );
                })}
              </div>
            )}
          </div>
        </div>

        {/* Recent signups */}
        <div className="card" style={{ gridColumn: '1 / -1' }}>
          <div style={{ padding: '1.25rem 1.5rem', borderBottom: '1px solid var(--color-border)' }}>
            <h3 style={{ margin: 0, fontSize: '1rem', color: 'var(--color-gold)' }}>Negocios Recientes</h3>
          </div>
          <div className="table-wrapper">
            <table>
              <thead>
                <tr>
                  <th>Negocio</th>
                  <th>Plan</th>
                  <th>Estado</th>
                  <th>Usuarios</th>
                  <th>Registro</th>
                </tr>
              </thead>
              <tbody>
                {(data.recent_businesses || []).map(b => (
                  <tr key={b.id}>
                    <td><div style={{ fontWeight: 600 }}>{b.name}</div></td>
                    <td><span className="badge badge-secondary" style={{ textTransform: 'capitalize' }}>{b.plan_name}</span></td>
                    <td><span className={`badge badge-${b.is_active ? 'success' : 'danger'}`}>{b.is_active ? 'Activo' : 'Inactivo'}</span></td>
                    <td style={{ color: 'var(--color-text-muted)' }}>{b.user_count || 0}</td>
                    <td style={{ color: 'var(--color-text-muted)', fontSize: '0.8rem' }}>
                      {b.created_at ? new Date(b.created_at).toLocaleDateString('es-CO') : '—'}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
}
